module.exports = __webpack_public_path__ + "static/robotMain_03-2f244bd7820e13ac3afc0641dd9d0b6f.png";